export const phoneNumber = { label: '02233/4028248', value: '+4922334028248' };
export const faxNumber = { label: '02233/4028249', value: '+4922334028249' };
export const mailAddress = {
  label: 'info@autoglas-am-rhein.de',
  value: 'info@autoglas-am-rhein.de',
};
